import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classNames from 'classnames';
import Icon from '@components/@core/Icon';

const CommunityHeader = ({ activeRoute, activeRouteUrl, backTitle, childRoute, searchTitle, addTitle, onBack, onModal, onSearch }) => {
    const navigate = useNavigate();
    return (
        <Row className="d-flex ssm-column mx-0 mb-3 ps-0 ssp-l-2">
            <Col sm={7} className="d-h-start px-0 pt-3 pb-2">
                <span className="dsl-b14 text-400 cursor-pointer" onClick={() => navigate('/community/home')}>
                    Community
                </span>
                {activeRoute && (
                    <>
                        <Icon name="fas fa-chevron-right ms-2" size={12} color="#969faa" />
                        <span className={classNames('dsl-b14 ms-2 cursor-pointer', childRoute && 'text-400')} onClick={() => navigate(`/${activeRouteUrl || activeRoute.toLowerCase()}`)}>
                            {activeRoute}
                        </span>
                    </>
                )}
                {childRoute && (
                    <>
                        <Icon name="fas fa-chevron-right ms-2" size={12} color="#969faa" />
                        <span className="dsl-m14 ms-2 me-3 truncate">{childRoute}</span>
                    </>
                )}
            </Col>
            <Col sm={5} className="d-h-end ssm-jc-between ps-0 pt-0 ssp-t-2 pe-lg-0">
                {searchTitle && (
                    <div className="d-h-start cursor-pointer me-3 me-md-5" onClick={onSearch}>
                        <Icon name="fas fa-search me-2" size={14} color="#376caf" />
                        <span className="dsl-p14">Search {searchTitle}</span>
                    </div>
                )}
                {backTitle ? (
                    <div className="d-h-start cursor-pointer" onClick={onBack}>
                        <Icon name="fas fa-arrow-left me-2" size={12} color="#376caf" />
                        <span className="dsl-p14">Back to {backTitle}</span>
                    </div>
                ) : (
                    <div className="d-h-start me-3 me-md-4">
                        {addTitle && (
                            <div className="cursor-pointer" onClick={onModal}>
                                <Icon name="fas fa-plus me-2" size={14} color="#376caf" />
                                <span className="dsl-p14">Add {addTitle}</span>
                            </div>
                        )}
                    </div>
                )}
            </Col>
        </Row>
    );
};

CommunityHeader.propTypes = {
    activeRoute: PropTypes.string,
    addTitle: PropTypes.string,
    backTitle: PropTypes.string,
    childRoute: PropTypes.string,
    searchTitle: PropTypes.string,
    onBack: PropTypes.func,
    onModal: PropTypes.func,
    onSearch: PropTypes.func,
};

CommunityHeader.defaultProps = {
    activeRoute: null,
    addTitle: null,
    backTitle: null,
    childRoute: null,
    searchTitle: null,
    onBack: () => {},
    onModal: () => {},
    onSearch: () => {},
};

export default CommunityHeader;
